import { Schema, defineTable } from 'squid';
export const claimReviewsTable = defineTable('claim_reviews', {
    claim_number: Schema.String,
    reviewer_id: Schema.String,
    name: Schema.String,
});
